import { render, staticRenderFns } from "./EditOrderProduct.vue?vue&type=template&id=829a5d96"
import script from "./EditOrderProduct.vue?vue&type=script&lang=js"
export * from "./EditOrderProduct.vue?vue&type=script&lang=js"
import style0 from "./EditOrderProduct.vue?vue&type=style&index=0&id=829a5d96&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports